import { Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createOrg } from '../actions/sessionActions';
import { useApi } from '../hooks/useApi';
import { AdminApi, OrgToJSON } from '@raptormaps/raptor-internal-client-ts';
import { useDispatch } from 'react-redux';
import { Button } from '@raptormaps/button';
import { createOrgSuccess } from '../actions/sessionActions';
import toastr from 'toastr';

/**
 * Component for creating a new organization with a master user email
 * @param props
 * @returns {*}
 * @constructor
 */
const CreateOrganizationComponent = props => {
  const adminApiClient = useApi(AdminApi, {
    basePath: window.REACT_APP_API_ENDPOINT_V2,
  });

  const dispatch = useDispatch();
  /**
   * Make api call to create the new org
   * @param e
   */
  const createOrganization = e => {
    e.stopPropagation();
    e.preventDefault();
    const orgName = e.target[0].value;
    const masterEmail = e.target[1].value.toLowerCase();

    adminApiClient
      .adminCreateOrg({
        admin_create_org_request: {
          name: orgName,
          orgType: props.type,
          masterEmail: masterEmail,
        },
      })
      .then(response => {
        let org = OrgToJSON(response.org);
        dispatch(createOrgSuccess(org));
        props.onCreateSuccess && props.onCreateSuccess(org);
        toastr.success(
          'Successfuly created org, an email was sent to ' + masterEmail,
        );
      })
      .catch(err => {
        toastr.error(err);
        console.log(err);
      });
  };

  let FieldGroup = ({ id, label, help, ...props }) => {
    return (
      <FormGroup style={{ width: '300px' }} controlId={id}>
        <FormLabel>{label}</FormLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  };

  return (
    <Form onSubmit={createOrganization} {...props}>
      <FieldGroup
        id="formControlsOrganizationName"
        type="text"
        label="Organization Name"
        placeholder="Big Corp"
      />
      <FieldGroup
        id="formControlsEmail"
        type="text"
        label="Master Email"
        placeholder="name@company.com"
      />
      <Button type="submit">Create</Button>
    </Form>
  );
};

const mapDispatchToProps = dispatch => ({
  sessionActions: bindActionCreators({ createOrg }, dispatch),
});

export default connect(null, mapDispatchToProps)(CreateOrganizationComponent);
